export enum WorkOrderFlowCodes {
    CreazionePratica = '0050',
    ModificaPratica = '0550',
    CancellazionePratica = '0550',
}
